import { useCallback, useEffect, useRef, useState } from 'react';

// Shared by letter construction and numeric ordering. IDs, not labels, identify tokens.
export default function useSequenceSelection({ questionKey, capacity, tokenIds }) {
  const [selectedIds, updateState] = useState([]);
  const current = useRef([]);
  const setSelectedIds = useCallback((next) => {
    const value = typeof next === 'function' ? next(current.current) : next;
    current.current = value;
    updateState(value);
    return value;
  }, []);
  useEffect(() => { setSelectedIds([]); }, [questionKey, setSelectedIds]);
  const select = (id) => {
    const tokenId = String(id);
    if (current.current.length >= capacity || current.current.includes(tokenId) || !tokenIds.includes(tokenId)) return null;
    return setSelectedIds([...current.current, tokenId]);
  };
  const remove = (id) => setSelectedIds(current.current.filter((value) => value !== String(id)));
  return { selectedIds, setSelectedIds, select, remove,
    undo: () => setSelectedIds(current.current.slice(0, -1)), clear: () => setSelectedIds([]) };
}
